
import { Vue, Component, Prop, Model, Emit } from 'vue-property-decorator';
import S3Image from "@/components/common/s3-image.vue";
import ItemChip from '@/components/common/ItemChip.vue';
import { Project, Project_Activity, User } from '@/generated/graphql';
import { hslColorFromName } from "@/utils/hslColorFromName";
import moment from 'moment';
import visitTypeDisplayMap from "@/entities/VisitType";
import { getTimezoneFromLocationString, displayTimeInLocationTimezone, deserializeTimezone } from "@/utils/timezoneUtils";
import { VUE_GOOGLEMAP_API_KEY } from "@/data/constants";

enum MODE {
    ACCEPT = "ACCEPT",
    REJECT = "REJECT",
}

@Component({
    components: {
        ItemChip,
        S3Image,
    },
})
export default class VisitsTable extends Vue {
    @Prop({ type: Array, required: true }) readonly headers!: Array<{
        text: string;
        value: string;
        badge?: boolean;
    }>;
    @Prop({ type: Object, required: true }) readonly data!: Project;
    @Prop({ type: String, required: true }) readonly currentMode: MODE;
    @Prop({ type: Array, default: () => [] }) readonly selectedItems!: any[];
    @Prop({ type: Boolean, default: false })
    readonly areAllItemsSelected!: boolean;
    @Prop({ type: Function, default: () => { } }) readonly handleSelectAll!: (
        event: Event
    ) => void;
    @Prop({ type: Function, default: () => { } })
    readonly handleRowCheckboxChange!: (item: any) => void;

    isInPopup!: boolean;

    isSelected(item: any): boolean {
        if (this.areAllItemsSelected) return true;
        return this.selectedItems.some(
            (selectedItem) => selectedItem.id === item.id
        );
    }

    initial(item): string {
        const firstName = item.user?.given_name;
        const lastName = item.user?.family_name;

        if (!firstName && !lastName) {
            return ''
        }

        const givenName = firstName ? firstName.trimLeft()[0] : '';
        const familyName = lastName ? lastName.trimLeft()[0] : '';
        return `${givenName}${familyName}`;
    }

    bgStyle(item): object {
        return {
            background: hslColorFromName(this.initial(item) || ""),
        };
    }


    formattedDate(date): string {
        if (date) {
            return moment(date).format("MMM D, YYYY");
        } else {
            return "n/a"
        }
    }

    typeOfVisit(visit): string {
        return this.getVisitType(visit.type_of_visit);
    }

    getVisitType(type: string | undefined): string {
        if (!type) return "n/a";
        return (
            visitTypeDisplayMap[type] ||
            type
                .replace(/_/g, " ")
                .toLowerCase()
                .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
        );
    }

    loadLocationTimezone(tz) {
        if (!tz) return null;
        try {
            const timezone = deserializeTimezone(tz);
            if (!timezone) {
                return null;
            }
            return timezone;
        } catch (error) {
            console.error("Error loading timezone:", error);
            return null;
        }
    }

    formattedTime(time, timezone): string {
        if (!time) return "n/a";
        const locationTimezone = this.loadLocationTimezone(timezone);
        if (locationTimezone) {
            return displayTimeInLocationTimezone(time, locationTimezone, "h:mm A");
        } else {
            return moment(time).format("h:mm A");
        }

    }

    get areAllSelected(): boolean {
        return this.data.project_activities.every((item: any) => this.isSelected(item));
    }

    get defaultImageClasses(): string {
        return 'inline-block rounded-full object-cover object-center';
    }

    get getAvatrClass() {
        return "chipHeight flex-shrink-0 circleWidth rounded-full bg-primary-500 flex items-center text-xs justify-center text-white";
    }

}
